export default {
  root: {
    borderRadius: 8
  }
};
